export default __webpack_public_path__ + "static/media/arrow_right.715b161c.svg";